module.exports = __webpack_public_path__ + "img/vertical_3_5_7016.116b9349.png";